export interface Campaign {
  id: string
  title: string
  status: CampaignStatus
  vastUrl: string
  createdAt: number
}

export interface CampaignInput {
  id?: string
  title: string
  status: CampaignStatus
  vastUrl: string
}

export enum CampaignStatus {
  Paused = 'paused',
  Live = 'live',
}

export const CampaignDefault: CampaignInput = {
  title: '',
  status: CampaignStatus.Live,
  vastUrl: '',
}
